import styled from 'styled-components';

const CheckMarkIcon = styled.svg`
  color: ${(props) => props.theme.carvana.green.primary};
  fill: ${(props) => props.theme.carvana.green.primary};
  height: 28px;
  margin-bottom: -4px;
  margin-left: 10px;
  width: 28px;
`;

export const CheckMark = () => (
  <CheckMarkIcon focusable="false" viewBox="0 0 22 22" aria-hidden="true">
    <g>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </g>
  </CheckMarkIcon>
);

export const Text = styled.p`
  color: ${(props) => props.theme.carvana.gray.dark};
`;

export const Line = styled.span`
  display: inline-block;
`;
